import React from "react";
import { Box, Typography } from "@mui/material";

export const ChartTooltip = ({ active, payload, label }) => {
    if (!active || !payload || !payload.length) return null;

    const total = payload.reduce((sum, entry) => sum + entry.value, 0);

    return (
        <Box
            sx={{
                bgcolor: "white",
                p: 1.5,
                border: "1px solid #e5e7eb",
                borderRadius: 1,
                boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
            }}
        >
            <Typography
                sx={{
                    fontSize: "0.875rem",
                    fontWeight: 600,
                    color: "#111827",
                    mb: 1,
                }}
            >
                {label}
            </Typography>
            {payload.map((entry, index) => (
                <Typography
                    key={index}
                    sx={{
                        fontSize: "0.75rem",
                        color: "#6b7280",
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 2,
                    }}
                >
                    <span style={{ color: entry.color }}>{entry.name}:</span>
                    <span>{entry.value}</span>
                </Typography>
            ))}
            <Typography
                sx={{
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    color: "#111827",
                    mt: 1,
                    pt: 1,
                    borderTop: "1px solid #e5e7eb",
                }}
            >
                Total: {total}
            </Typography>
        </Box>
    );
};
